import config from 'app-config'

export const keystoneEndpoint = `/keystone`
export const keystoneAdminEndpoint = `${config.host}/keystone_admin`
export const qbertBaseUrlTpl = '/clusters/:clusterId/k8sapi/'
export const sunpikeBaseUrlTpl =
  '/sunpike/apis/opt.pf9.io/v1beta1/namespaces/:namespace/clusters/:clusterName/proxy/'
